.fullImage {
  composes: -fullImage from "./util.module.css";
}
